import { ReactComponent as MySVG } from "./chevron-up.svg";
import ScrollToTop from "react-scroll-to-top"

const ScrollToTopButton = () => {
    return (
        <ScrollToTop smooth className={'d-xl-none'} width="200" height="200" color={"#fff"} component={<MySVG />} />
    )
}

export default ScrollToTopButton